// extracted by mini-css-extract-plugin
export default {"ranger":"FooterLoadedNav_ranger__rt7uj"};